import React, { useContext } from 'react'
import { Details } from './Details'
import classNames from 'classnames'
import AnimateHeight from 'react-animate-height'
import { useTranslation } from 'utils/useTranslation'

export function ProductCardMobile({ accessory, isInCart, onAddToCartClick, context }) {
  const {
    order
  } = useContext(context)

  const accessoryStrings = useTranslation('accessories_shop.misc') ?? {}
  const [showDetails, setShowDetails] = React.useState(false)
  const fitsModelNames = accessory.fits.map((fit) => fit.label)
  const paymentType = order.paymentType ?? 'cash'

  return (
    <div className={classNames('mtt-product-card-mobile', { active: showDetails, 'in-cart': isInCart })}>
      <div className='mtt-product-card-mobile__inner'>
        <div className='mtt-product-card-mobile__image-wrapper'>
          <img src={accessory.image} alt='' />
        </div>

        <div className='mtt-product-card-mobile__content-wrapper'>
          <div className='mtt-product-card-mobile__title'>
            <h3 className='mtt-title'>{accessory.title}</h3>
          </div>

          <div className='mtt-terms'>{fitsModelNames.join(', ')}</div>

          <div className='mtt-product-card-mobile__price-wrapper'>
            <div className='mtt-product-card-mobile__price'>
              <div className='mtt-price'>
                {paymentType === 'cash' ? accessory.price.formatted : accessory.price_leasing.formatted}
              </div>

              <div className='mtt-slide-button' onClick={() => setShowDetails(!showDetails)}>
                {showDetails ? accessoryStrings.hide_details : accessoryStrings.show_details}
              </div>
            </div>

            <AnimateHeight duration={500} height={showDetails ? 'auto' : 0}>
              <div className='mtt-product-card-mobile__details'>
                <Details
                  description={accessory.description}
                  specifications={accessory.specifications}
                  fits={accessory.fits}
                  isInCart={isInCart}
                  onAddToCartClick={onAddToCartClick}
                />
              </div>
            </AnimateHeight>
          </div>
        </div>
      </div>
    </div>
  )
}
